jQuery(document).ready(function($) {

	$.sidebar_navigation = {
		init: function() {
			$.sidebar_navigation.events();
		},

		events: function() {
			var oDocument = $(document);

			oDocument.on('click', '.m-sidebar-navigation__item.level-2.menu-item-has-children > .m-sidebar-navigation__link', function(e) {
				e.stopPropagation();
				e.preventDefault();

				$(this).parent().toggleClass('active');
			});
		},
	};

});